// // src/index.js

// import React from 'react';
// import { createRoot } from 'react-dom/client'; // Updated import for React 18
// import { BrowserRouter } from 'react-router-dom';
// import App from './App';
// import './index.css';
// import reportWebVitals from './reportWebVitals';

// // Updated render method for React 18
// const container = document.getElementById('root');
// const root = createRoot(container); // Create a root.
// root.render(
//   <React.StrictMode>
//     <BrowserRouter>
//       <App />
//     </BrowserRouter>
//   </React.StrictMode>
// );

// reportWebVitals(console.log);


// import React from 'react';
// import { createRoot } from 'react-dom/client'; // Updated import for React 18
// import { MemoryRouter } from 'react-router-dom'; // Import MemoryRouter instead of BrowserRouter
// import App from './App';
// import './index.css';
// import reportWebVitals from './reportWebVitals';
// import { unstable_scheduleCallback as scheduleCallback } from 'scheduler';

// // Updated render method for React 18
// const container = document.getElementById('root');
// const root = createRoot(container); // Create a root.
// root.render(
//   <React.StrictMode>
//     <MemoryRouter> {/* Use MemoryRouter instead of BrowserRouter */}
//       <App />
//     </MemoryRouter>
//   </React.StrictMode>
// );

// scheduleCallback(0, () => {
//   reportWebVitals(console.log);
// });


// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App'; // This should match the default export from `App.js`
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
